export default {
    /**
     * 修复：智能转换时间戳（兼容秒级和毫秒级）
     * 后端返回的是秒级时间戳，需要转换为毫秒
     */
    normalizeTimestamp(timestamp) {
      // 如果小于 10000000000，则认为是秒级时间戳（2001年之前的毫秒时间戳才会小于这个值）
      return timestamp < 10000000000 ? timestamp * 1000 : timestamp;
    },
    
    formatDate (value) {
        let date = new Date(this.normalizeTimestamp(value));
        // let y = date.getFullYear();
        // let MM = date.getMonth() + 1;
        // MM = MM < 10 ? ('0' + MM) : MM;
        // let d = date.getDate();
        // d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        // return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
        return h + ':' + m + ':' + s;
      },
      formatDatetow (value) {
        let date = new Date(this.normalizeTimestamp(value));
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        // let h = date.getHours();
        // h = h < 10 ? ('0' + h) : h;
        // let m = date.getMinutes();
        // m = m < 10 ? ('0' + m) : m;
        // let s = date.getSeconds();
        // s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d ;
        // return h + ':' + m + ':' + s;
      },
      formatDatethree (value) {
        let date = new Date(this.normalizeTimestamp(value));
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      },
}